import React from "react";

import { Activity } from "../../../backend/generated/activity-model";
import { Skill } from "../../../backend/generated/skill-model";
import { UpdateActivityInput } from "../../../backend/generated/update-activity-input";
import { UpdateSkillInput } from "../../../backend/generated/update-skill-input";
import { ActivityType, InvestmentClass } from "../../../backend/types/utils";
import { ExperienceInputTypeUnion, ExperienceType } from "../../../store/user/types";
import { SubformProps } from "../../SubformProps";
import { InputFieldPropsUnion } from "../elements/types";
import { ActivityField, ActivityInputTypeKey } from "./ActivityField";
import { KeyUndefinedError } from "./InputField";
import { SkillField, SkillInputTypeKey } from "./SkillField";

type ExperienceFieldDescriptor = {
  [key in keyof InputFieldPropsUnion]: any;
}

export type ExperienceInputTypeKey = keyof ExperienceInputTypeUnion;

export type ExperienceInputTypeSubkey =
  | ActivityInputTypeKey
  | SkillInputTypeKey

export type ExperienceInputTypeIndexkey =
  | ActivityType
  | InvestmentClass

type ExperienceFieldProps = SubformProps<ExperienceType> & Partial<ExperienceFieldDescriptor> & {
  id: ExperienceInputTypeKey;
  indexkey: ExperienceInputTypeIndexkey;
  noLabels?: boolean;
  subkey: ExperienceInputTypeSubkey;
}

export const ExperienceField = (props: ExperienceFieldProps) : JSX.Element | null => {
  // Subform Props

  const {
    errors,
    indexkey,
    setFieldValue,
    subkey,
    touched,
    values,
  } = props;

  const id = props.id as ExperienceInputTypeKey;

  // Building Component

  switch (id) {
    case "activities": {
      const index = values.activities ? Array.from(values.activities).findIndex((experience: any) => experience.type === indexkey) : -1;
      return (
        <ActivityField
          { ...props }
          errors={errors.activities?.[index] || {}}
          id={subkey as ActivityInputTypeKey}
          setFieldValue={(
            id: string, value: any
          ) => {
            let field = values.activities ? [...values.activities] : [];

            if (index < 0) {
              field.push(new Activity());
              field[field.length - 1].type = indexkey as ActivityType;
              field[field.length - 1][id] = value;
            } else {
              field[index][id] = value;
            }

            setFieldValue(
              'activities',
              field
            );
          }}
          setValues={(values: any) => setFieldValue(
            'activities',
            values
          )}
          touched={touched.activities?.[index] || {}}
          values={values.activities?.[index] || new UpdateActivityInput()}
        />
      );
    }
    case "skills": {
      const index = values.skills ? Array.from(values.skills).findIndex((experience: any) => experience.type === indexkey) : -1;
      return (
        <SkillField
          { ...props }
          errors={errors.skills?.[index] || {}}
          id={subkey as SkillInputTypeKey}
          setFieldValue={(
            id: string, value: any
          ) => {
            let field = values.skills ? [...values.skills] : [];

            if (index < 0) {
              field.push(new Skill());
              field[field.length - 1].type = indexkey as InvestmentClass;
              field[field.length - 1][id] = value;
            } else {
              field[index][id] = value;
            }

            setFieldValue(
              'skills',
              field
            );
          }}
          setValues={(values: any) => setFieldValue(
            'skills',
            values
          )}
          touched={touched.skills?.[index] || {}}
          values={values.skills?.[index] || new UpdateSkillInput()}
        />
      );
    }
    default: {
      KeyUndefinedError(id); // Compile-time check for unhandled cases
    }
  }

  return <></>;
}
